export const LIGHT = 'light';
export const DARK = 'dark';

export const TYPOGRAPHY = {
  fontFamily: ['"Google Sans"', 'Inter', 'system-ui', 'sans-serif'].join(','),
};

export const COMPONENTS = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontSize: '14px',
        borderRadius: '8px',
        fontWeight: 500,
        padding: '10px 20px',
        boxShadow: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: 'none',
          opacity: 0.9,
        },
      },
    },
  },

  MuiDivider: {
    styleOverrides: {
      root: {
        margin: '24px 0',
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          fontSize: '14px',
          transition: 'border-color 0.2s ease',
          '& fieldset': {
            borderColor: 'rgba(74, 63, 53, 0.15)',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(74, 63, 53, 0.3)',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: '14px',
          padding: '12px 14px',
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        padding: '6px 12px',
        borderRadius: '8px',
        height: '32px',
        fontSize: '13px',
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        fontSize: "14px",
        borderRadius: "8px",
        margin: "4px 6px",
        padding: "10px 12px",
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "8px",
        padding: "8px 12px",
        fontSize: "12px",
        boxShadow:
          theme.palette.mode === "dark"
            ? "0px 10px 30px rgba(0, 0, 0, 0.5)"
            : "0px 10px 30px rgba(74, 63, 53, 0.12)",
      }),
      arrow: ({ theme }) => ({
        color: theme.palette.background.paper,
      }),
    },
  },
};

export const PRIMARY_COLOR = "#fff";